let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jjoMI")).then(() => parcelRequire('h0DlA'));